export const environment = {
  production: false,
  openBankingApiUrl:"https://api.dev.openbanking.disruptionsuite.io",
   //dacApiUrl:"https://dev.ob.digitalapicraft.com",
   //businessApiUrl:"https://dev.ob.business.digitalapicraft.com",
  // firstDirectApiUrl:"https://dev.ob.firstdirect.digitalapicraft.com",
  // hsbcKineticApiUrl:"https://dev.ob.hsbckinetic.digitalapicraft.com",
  // hsbcnetApiUrl:"https://dev.ob.hsbcnet.digitalapicraft.com",
  // mandsbankApiUrl:"https://dev.ob.mandsbank.digitalapicraft.com",
   fireBase:"https://hsbc-openbanking-c4d49-default-rtdb.europe-west1.firebasedatabase.app/openbanking/user-consents/", // Dev
  //  fireBase:"https://hsbc-obss-preprod-default-rtdb.europe-west1.firebasedatabase.app/openbanking/user-consents/" // preprod
};